import React, { useState, useCallback } from "react";
import { getSmoothStepPath, EdgeLabelRenderer, BaseEdge } from "@xyflow/react";
import { useNodeStorage } from "../../../stores/useNodeStorage";

const EDGE_COLOR = "#b1b5c3";
const EDGE_COLOR_SELECTED = "#6366f1";
const EDGE_WIDTH = 1.5;
const EDGE_WIDTH_HOVER = 2;

/**
 * SmartEdge — Estilo n8n
 *
 * Curvas bezier suaves, botao de deletar discreto on hover.
 */
export default function SmartEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  selected,
  data,
}) {
  const [hovered, setHovered] = useState(false);
  const storageItems = useNodeStorage();

  const isRunning = data?.running ?? false;
  const isActive = hovered || selected;

  // Linhas retas com cantos arredondados
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    borderRadius: 8,
  });

  const handleDelete = useCallback(
    (evt) => {
      evt.stopPropagation();
      evt.preventDefault();
      storageItems.setNodesStorage(id);
      storageItems.setAct("deleteEdge");
    },
    [id, storageItems]
  );

  const color = isActive ? EDGE_COLOR_SELECTED : EDGE_COLOR;

  const computedStyle = {
    stroke: color,
    strokeWidth: isActive ? EDGE_WIDTH_HOVER : EDGE_WIDTH,
    transition: "stroke 0.15s, stroke-width 0.15s",
    ...(isRunning
      ? {
          strokeDasharray: "6 3",
          animation: "smartEdgeDash 0.6s linear infinite",
        }
      : {}),
    ...style,
  };

  return (
    <>
      {isRunning && (
        <style>
          {`@keyframes smartEdgeDash {
              to { stroke-dashoffset: -18; }
            }`}
        </style>
      )}

      {/* Caminho invisivel para deteccao de hover */}
      <path
        d={edgePath}
        fill="none"
        stroke="transparent"
        strokeWidth={20}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{ cursor: "pointer" }}
      />

      {/* Conexao visivel */}
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={markerEnd}
        style={computedStyle}
      />

      {/* Botao de deletar */}
      <EdgeLabelRenderer>
        <div
          style={{
            position: "absolute",
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            pointerEvents: "all",
            opacity: isActive ? 1 : 0,
            transition: "opacity 0.15s",
          }}
          className="nodrag nopan"
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          <button
            onClick={handleDelete}
            style={{
              width: 18,
              height: 18,
              borderRadius: "50%",
              border: "1px solid #e5e7eb",
              backgroundColor: "#fff",
              color: "#6b7280",
              fontSize: 11,
              fontWeight: 700,
              lineHeight: "16px",
              textAlign: "center",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 0,
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
            title="Remover conexao"
          >
            &times;
          </button>
        </div>
      </EdgeLabelRenderer>
    </>
  );
}
